import Offcanvas from "@components/core/Offcanvas";
import Auth from "@components/views/Auth";

function AuthOffcanvas({ open, initType, userAction, onHide, onAfterAuth = () => {} }) {
  return (
    <Offcanvas
      show={open}
      onHide={onHide}
      placement="bottom"
      size="lg"
    >
      <div className="d-flex flex-grow-1 justify-content-center align-items-center">
        <Auth
          initType={initType}
          userAction={userAction}
          onAfterAuth={onAfterAuth}
        />
      </div>
    </Offcanvas>
  );
}

export default AuthOffcanvas;
